<!--div class="col-md-12">
  <div class="row">
    <div class="col-md-2" style="height:100%;">
      <br>
      <p-panelMenu [model]="panelitems" [style]="{'width':'100%'}" [transitionOptions]="'300ms'"></p-panelMenu>
    </div>


      <p-drawer *ngIf="showVersionInfo" header="Versionsinformation SVOMS" [(visible)]="showVersionInfo" position="bottom" [style]="{ height: '80vh' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow': 'auto' }" (onHide)="showVersionInfo=false">
 
        <app-info></app-info>

</p-drawer>



    <div class="col-md-10">
      <router-outlet></router-outlet>

    </div>
  </div>
</div-->


<div class="d-flex d-justify-content-start gap-2">
  
    <div style="height:100%;">
      <br>
      <p-panelMenu [model]="panelitems" [style]="{'width':'100%'}" [transitionOptions]="'300ms'"></p-panelMenu>
    </div>


      <p-drawer *ngIf="showVersionInfo" header="Versionsinformation SVOMS" [(visible)]="showVersionInfo" position="bottom" [style]="{ height: '80vh' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow': 'auto' }" (onHide)="showVersionInfo=false">
 
        <app-info></app-info>

</p-drawer>



    <div style="width:100%;">
      <router-outlet></router-outlet>

    </div>
  
</div>

